import axios from 'axios';
import * as types from '../constants/ActionTypes';

function requestOnlineCommunityUserCount() {
  return {
    type: types.REQUEST_COMMUNITY_ONLINE_USER_COUNT,
    payload: undefined,
  };
}

function receiveOnlineCommunityUserCount(responseData) {
  return {
    type: types.RECEIVE_COMMUNITY_ONLINE_USER_COUNT_RESPONSE,
    payload: responseData.communityUsers,
  };
}

function receiveOnlineCommunityUserError() {
  return {
    type: types.RECEIVE_COMMUNITY_ONLINE_USER_COUNT_ERROR,
    payload: undefined,
  };
}

function fetchActiveCommunityUserCount() {
  return (dispatch) => {
    dispatch(requestOnlineCommunityUserCount());
    return axios
      .get('/smarthelp/active-users')
      .then((response) => dispatch(receiveOnlineCommunityUserCount(response.data)))
      .catch(() => dispatch(receiveOnlineCommunityUserError()));
  };
}

export default fetchActiveCommunityUserCount;
